import React from "react";
import { Container, Tab, Tabs, Spinner, Dropdown } from "react-bootstrap";
import MainLayout from "../../../_components/Common/MainLayout";
import useAssignedAssessments from "./useAssignedAssessments";
import { dateDiff } from "../../../_helpers/dateFormatter";
import { tagStatusColors } from "../../../_helpers/tagStatusColors";
import { assessmentKitFilter } from "./constant";
export default () => {
  const {
    isLoading,
    candidateAssignedAssessments,
    selectedFilter,
    candidateData,
    outerClickRef,
    onViewDetailsClick,
    onFilterChange,
  } = useAssignedAssessments();

  return (
    <MainLayout
      activeMenuItem="New Assessment Kit"
      pageName={"Assessment Kits"}
    >
      <Container className="footer-gap" ref={outerClickRef}>
        <div className="applied-job-board">
          <div className="hiring-process-dashboard kanban-board-main">
            {isLoading ? (
              <>
                <div className="d-flex align-items-center justify-content-center p-4">
                  <Spinner animation="border" variant="primary" />
                </div>
              </>
            ) : (
              <>
                <div className="row mb-4">
                  <div className="col-lg-6">
                    {/* <div className="custom-search-box ml-auto ">
                      <div className="search-box-with-icon shadow-sm">
                        <span className="icon">
                          <img
                            src="/assets/images/search-lg-icon.svg"
                            alt="search"
                          />
                        </span>
                        <input type="text" placeholder="Search" />
                      </div>
                    </div> */}
                  </div>
                  <div className="col-lg-6 d-flex justify-content-end">
                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="btn-white-new py-2 shadow-sm text-capitalize"
                      >
                        <img
                          src="/assets/images/filter-lines.svg"
                          alt="filter"
                          className="mr-2"
                        />
                        {selectedFilter}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {assessmentKitFilter.map((item) => (
                          <div
                            onClick={() => onFilterChange(item)}
                            className="dropdown-item cursor-pointer text-capitalize"
                            data-rr-ui-dropdown-item
                          >
                            {item}
                          </div>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>

                {Array.isArray(candidateData) && candidateData.length ? (
                  <>
                    <div className="row">
                      {Array.isArray(candidateData) &&
                        candidateData.map((item) => (
                          <div className="col-md-6 mb-4">
                            <div className="d-flex flex-column p-4 bg-white border position-relative h-100 border-radius-10">
                              <div className="upper">
                                <div className="d-flex justify-content-between">
                                  <div className="job-info d-flex mb-3">
                                    <h3 className="text-dark mb-1 text-capitalize mr-2">
                                      {item?.assessment_id &&
                                        item?.assessment_id?.title}
                                    </h3>
                                    <span
                                      className={tagStatusColors(item?.status)}
                                    >
                                      {item?.status}
                                    </span>
                                  </div>
                                </div>
                                <div className="mb-2">
                                  <div className="d-flex align-items-center fs-smallest  justify-content-between">
                                    <p className="text-grey-4 mb-0">
                                      <span className="border d-inline-block rounded-lg p-1 mr-2">
                                        Skills{" "}
                                        <span className="font-weight-medium text-dark bg-grey rounded-lg py-1 px-2">
                                          {item?.assessment_id &&
                                            item?.assessment_id?.skills &&
                                            item?.assessment_id?.skills.length}
                                        </span>{" "}
                                      </span>
                                      <span className="border d-inline-block rounded-lg p-1">
                                        Questions{" "}
                                        <span className="font-weight-medium  text-dark  bg-grey rounded-lg py-1 px-2">
                                          {item?.assessment_id &&
                                            item?.assessment_id
                                              ?.total_questions}
                                        </span>{" "}
                                      </span>
                                    </p>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center flex-wrap fs-smallest mb-3">
                                  <p className="mr-2 text-capitalize mb-0">
                                    {Array.isArray(
                                      item?.assessment_id &&
                                        item?.assessment_id?.skills
                                    ) &&
                                      item?.assessment_id &&
                                      item?.assessment_id?.skills.map(
                                        (skill) => (
                                          <span className="skill bg-grey border d-inline-block px-2 rounded-sm mr-2 my-1 mb-2">
                                            {skill?.skill_id &&
                                              skill?.skill_id?.skill}
                                          </span>
                                        )
                                      )}
                                  </p>
                                </div>
                              </div>
                              <div className="d-flex pt-2 justify-content-between align-items-center border-top  flex-md-wrap flex-lg-nowrap mt-auto">
                                <p className="mb-0 mr-2  text-grey-4 fs-smallest">
                                  Assinged{" "}
                                  {dateDiff(item?.created_at, new Date())} ago
                                </p>
                                <div className="job-bottom d-flex align-items-center justify-content-between ">
                                  <button
                                    onClick={() => onViewDetailsClick(item?.id)}
                                    className="border-0 bg-transparent text-primary py-0 mr-2 cursor-pointer text-nowrap font-weight-medium fs-smallest"
                                  >
                                    View Details
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </>
                ) : (
                  <div className="text-center">
                    <img src={"/assets/images/warning.png"} alt="error" />
                    <h3 className="text-danger mb-4">
                      No Assessment Kit assigned to you!
                    </h3>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </Container>
    </MainLayout>
  );
};
